

















// 3rd party libs
import {
    mapActions,
} from 'vuex';

export default {
    name: 'tutorial',
    props: {
        tutorialName: {
            type: String,
            default: '',
        },
        steps: {
            type: Array,
            default: () => [],
        },
        showOnce: {
            type: Boolean,
            default: false,
        },
        imageWidthClass: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        currentStepIndex: 0,
    }),
    computed: {
        currentStep() {
            return this.steps[this.currentStepIndex];
        },
        buttonText() {
            return (this.currentStepIndex === this.steps.length - 1 ? this.$t('global.finish') : this.$t('tutorial.next'));
        },
        automationId() {
            return this.currentStep.automationText || 'tutorial';
        },
    },
    methods: {
        ...mapActions('tutorial', ['toggleTutorial']),

        nextStep() {
            if (this.currentStepIndex === this.steps.length - 1) {
                this.finishTutorial();

                return;
            }
            this.currentStepIndex++;

            this.$emit('onNext');
        },

        previousStep() {
            if (this.currentStepIndex !== 0) {
                this.currentStepIndex--;

                this.$emit('onPrevious');
            }
        },

        finishTutorial() {
            this.$emit('onFinish');

            if (this.showOnce) {
                // Toggle the tutorial availability flag
                this.toggleTutorial({
                    tutorialName: this.tutorialName,
                    value: true,
                });
            }
        },
    },
};
